module.exports = __webpack_public_path__ + "img/Asset 83.d587bc66.svg";